<template>
<div>
  <el-progress v-if="socket_key" :percentage="progress"></el-progress>
  <div class="search-wrap">
    <el-button size="mini" @click="pageChange(1)">查询</el-button>
    <el-button size="mini" @click="getExcel()">导出</el-button>
<!--    <el-button size="mini" @click="ocr()">识别</el-button>-->
  </div>
  <div>
    <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'41%'}">
      <el-descriptions-item label="项目房产">
        {{mainObj.house_name?mainObj.house_name:'请选择项目房产'}}
      </el-descriptions-item>
      <el-descriptions-item label="抄表月份">
        <el-date-picker
          v-model="mainObj.read_month"
          size="mini"
          type="month"
          format="yyyy-MM"
          value-format="yyyy-MM"
          @change="pageChange(1)"
          placeholder="选择月">
        </el-date-picker>
      </el-descriptions-item>
      <el-descriptions-item label="仪表编号">
        <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" @change="pageChange(1)" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="仪表名称">
        <el-input size="mini" placeholder="请输入仪表名称" v-model="where.name" clearable @change="pageChange(1)"></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="仪表类型">
        <el-select size="mini" style="width: 100%" v-model="where.meter_type" clearable filterable placeholder="类型" class="kuan" @change="pageChange(1)">
          <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="能耗类型">
        <el-checkbox-group v-model="where.apportion_meter_types" @change="pageChange(1)">
          <el-checkbox v-for="item in apportion_meter_type_list" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-descriptions-item>
    </el-descriptions>
  </div>
<!--  <div>-->
<!--    <div class="header-tip">-->
<!--      总分摊费用： {{order_count_obj.allocated_amount}} 元-->
<!--    </div>-->
<!--  </div>-->
  <div>
    <el-table show-summary v-if="pageData" v-loading="loading" border :data="pageData.list" width="99%" height="60vh" >
<!--      <el-table-column type="selection" width="55"></el-table-column>-->
      <!--        <el-table-column prop="id" label="id" width="80"></el-table-column>-->
      <el-table-column prop="number" label="仪表编号 "  width="150">
        <template slot-scope="scope">
          <el-link type="primary">{{scope.row.number||'无仪表编号'}}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="仪表名称 " width="200"></el-table-column>
      <el-table-column prop="meter_level" label="仪表等级 " width="100"></el-table-column>
      <el-table-column prop="energy" label="能耗类型" width="100">
        <template slot-scope="scope">
          {{energy_obj[scope.row.energy]}}
        </template>
      </el-table-column>
      <el-table-column prop="apportion_tip_name" label="分摊类型" width="100">
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.apportion_meter_type===1?'纯用量分摊':'线损分摊'}}-->
<!--        </template>-->
      </el-table-column>
      <el-table-column prop="current_price" label="费用单价 "  width="100"></el-table-column>
      <el-table-column prop="dosage_number" label="本表计量"  width="100"></el-table-column>

      <el-table-column prop="dosage_number" label="线损差值"  width="100">
        <template slot-scope="scope">
          <el-tooltip effect="dark" :content="scope.row.dosage_fun_name" placement="bottom">
            <span>{{scope.row.x_dosage_number}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="xs_accumulate_dosage_number" label="线损累计量"  width="100"></el-table-column>
      <el-table-column prop="total_dosage_number" label="总计用量"  width="100">
        <template slot-scope="scope">
          <el-tooltip effect="dark" content="总计用量=本表计量+线损累计量" placement="bottom">
            <span style="color: #000000;font-weight: bold">{{scope.row.total_dosage_number}}</span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column prop="total_amount" label="总费用"  width="100">
        <template slot-scope="scope">
          <span style="color: #ff0f0f;font-weight: bold">{{scope.row.apportion_meter_type===1?scope.row.amount:scope.row.x_amount}}</span>
        </template>
      </el-table-column>

      <el-table-column prop="last_read_number" label="上次读数" width="100"></el-table-column>
      <el-table-column prop="read_number" label="本次读数" width="100"></el-table-column>
      <el-table-column prop="magnification" label="倍率" width="100"></el-table-column>

      <el-table-column prop="magnification" label="程序核对计算用量" width="100">
        <template slot-scope="scope">
          {{reNumber((scope.row.read_number-scope.row.last_read_number)*scope.row.magnification)}}
        </template>
      </el-table-column>

      <el-table-column label="操作 " width="280">
        <template slot-scope="scope">
          <!--            <el-button type="primary" size="mini" icon="el-icon-edit" @click="update(scope.row)" v-if="ERP.isPermission(4007002006)||ERP.isPermission(21004001006)||ERP.isPermission(8006001006)||ERP.isPermission(30006001006)">能耗</el-button>-->
          <el-button size="mini" @click="showDosageNumberMap(scope.row.meter_id)">能耗图</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div style="margin-top: 20px;text-align: center;margin-right: 20px;">
    <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
  </div>

</div>
</template>

<script>
import {Loading} from "element-ui";
import Http from "../../common/Http";
import MeterOrderFlowHelp from "../../common/MeterOrderFlowHelp";
import MeterHttp from "../../common/MeterHttp";

export default {
  name: "MeterOrderNoteList",
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      where:{
        number:"",
        name:"",
        apportion_meter_types:[1,2],
        meter_type:""
      },
      apportion_meter_type_list:[{name:"存用量",val:1},{name:"线损",val:2}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      energy_obj:{1:"业主能耗",2:"物业能耗",3:"分摊能耗"},
      meter_type_list: [],
      loading: false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      multipleSelection: [],
      order_count_obj:{
        allocated_amount:0,
        total_dosage_number:0
      },
      progress: 0,
      socket_key:null,
    }
  },
  mounted() {
    this.getMeterTypeList();
    this.pageChange(1)
  },
  methods:{
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    pageChange(i){
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrder/getMeterNoteList",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
        that.multipleSelection = []
      })
    },
    getExcel() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(this.where);
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      where.read_month=that.mainObj.read_month;
      where.apportion_meter_types=where.apportion_meter_types.join(',');
      MeterHttp.post("MeterOrder/getExcel",{
        project_id:that.mainObj.project_id,
        ...where,
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        pageSize: this.pageData.pageSize
      }, res => {
        if (res.code) {
          if(res.data.indexOf("http")===-1){
            window.open(__HTTP__.defaults.baseURL +res.data)
          }else {
            window.open(res.data)
          }
        }
        that.loading = false;
      })
    },
  },
  watch:{
    "mainObj.house_name":function (n,o) {
      if(n){
        this.pageChange(1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-tip{
  margin: 5px 0;
  padding: 5px 10px;
  background-color: #f56c6c;
  color: #FFFFFF;
  border-radius: 4px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/MeterOrderNoteList.vue